// P3-005: Skill effect battle behavior mappings (GDD section 4.5.5)

import { SkillEffectType } from '@/shared/types/common';

/** Defines how each SkillEffectType behaves in battle */
export interface SkillBattleBehavior {
  type: SkillEffectType;
  description: string;
  /** Whether this effect is instant or lasts multiple turns */
  isInstant: boolean;
  /** Whether this effect targets the board */
  affectsBoard: boolean;
  /** Maximum cap for effect value (if any) */
  maxValue?: number;
}

export const SKILL_BATTLE_BEHAVIORS: Record<SkillEffectType, SkillBattleBehavior> = {
  [SkillEffectType.DAMAGE]: {
    type: SkillEffectType.DAMAGE,
    description: 'Deal extra damage to enemy',
    isInstant: true,
    affectsBoard: false,
  },
  [SkillEffectType.HEAL]: {
    type: SkillEffectType.HEAL,
    description: 'Restore turns (extend deadline)',
    isInstant: true,
    affectsBoard: false,
    maxValue: 3, // Cannot heal more than 3 turns at once
  },
  [SkillEffectType.BUFF_ATK]: {
    type: SkillEffectType.BUFF_ATK,
    description: 'Increase attack power for duration',
    isInstant: false,
    affectsBoard: false,
  },
  [SkillEffectType.BUFF_DEF]: {
    type: SkillEffectType.BUFF_DEF,
    description: 'Reduce overload penalty for duration',
    isInstant: false,
    affectsBoard: false,
  },
  [SkillEffectType.DEBUFF_ENEMY]: {
    type: SkillEffectType.DEBUFF_ENEMY,
    description: 'Increase damage received by enemy for duration',
    isInstant: false,
    affectsBoard: false,
  },
  [SkillEffectType.BOARD_CHANGE]: {
    type: SkillEffectType.BOARD_CHANGE,
    description: 'Convert random tiles to agent element color',
    isInstant: true,
    affectsBoard: true,
    maxValue: 10, // Cannot convert more than 10 tiles at once
  },
  [SkillEffectType.COOLDOWN_REDUCE]: {
    type: SkillEffectType.COOLDOWN_REDUCE,
    description: 'Reduce all team skill CDs by value',
    isInstant: true,
    affectsBoard: false,
  },
};

/** Maximum turns HEAL skill can extend deadline */
export const MAX_HEAL_TURNS = 3;

/** Maximum tiles BOARD_CHANGE can convert in one activation */
export const MAX_BOARD_CHANGE_TILES = 10;
